import React from 'react';
import styled from 'styled-components';

function Bottom() {
    const scholarLink = "https://scholar.google.com/citations?user=kZa_Pr0AAAAJ&hl=en";
    const gitHubLink = "https://github.com/lukasaerik/";
    const instagramLink = "https://www.instagram.com/lukaserikssonwoodworking/";

    return (
        <BottomDiv>
            <div>
                <a target="_blank" rel="noreferrer" href={instagramLink}>Instagram</a>
                <a target="_blank" rel="noreferrer" href={gitHubLink}>GitHub</a>
                <a target="_blank" rel="noreferrer" href={scholarLink}>Scholar</a>
            </div>
        </BottomDiv>
    )
}


const BottomDiv = styled.div`
    div {
        display: flex;
        justify-content: space-evenly;
        align-contents: center;
        padding: 50px 0 50px 0;
        background-color: #191220;
        flex-wrap: wrap;
        gap: 16px;
    }

    a {
        color: #C44F8C;
        text-decoration: none;
        font-size: 20px;
    }
`


export default Bottom
